import React, { FC, Fragment, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    Divider,
    Icon,
    Paper,
    TextField,
    Typography,
} from '@mui/material';
import CreateConstructionAi from './create-construction-ai/create-construction-ai.component';
import Constructions from './constructions/constructions.component';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { SupplierOrderContext } from 'pages/order-flow/supplier-order/supplier-order-context';

type ConstructionsStepProps = {
    onBackClick: () => void;
    onNextClick: () => void;
};
const ConstructionsStep: FC<ConstructionsStepProps> = ({ onBackClick, onNextClick }) => {
    const { t: translate } = useTranslation(['common', 'orders']);
    const { order, updateOrder } = useContext(SupplierOrderContext);
    const [comment, setComment] = useState('');

    const handleCommentChange = (comment: string) => {
        setComment(comment);
        updateOrder({ ...order, comment });
    };

    useEffect(() => {
        setComment(order.comment);
    }, [order.comment]);

    return (
        <Fragment>
            <Box>
                <Box mb={2}>
                    <Typography variant="h1">{translate('orders:CONSTRUCTIONS')}</Typography>
                </Box>
                <Box mb={2}>
                    <Divider />
                </Box>
                <Box mb={4}>
                    <Accordion>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Box display="flex" alignItems="center">
                                <Icon sx={{ marginRight: 1 }}>
                                    <AutoAwesomeIcon sx={{ color: 'ai.main' }} />
                                </Icon>
                                <Typography variant="h4" component="span">
                                    {translate('orders:ADD_CONSTRUCTION_WITH_AI')}
                                </Typography>
                            </Box>
                        </AccordionSummary>
                        <AccordionDetails>
                            <CreateConstructionAi />
                        </AccordionDetails>
                    </Accordion>
                </Box>
                <Box mb={4}>
                    <Paper variant="outlined">
                        <Box p={4}>
                            <Constructions />
                        </Box>
                    </Paper>
                </Box>
                <Box mb={4}>
                    <Box mb={2}>
                        <Typography variant="h3" gutterBottom>
                            {translate('orders:COMMENT')}
                        </Typography>
                    </Box>
                    <Box>
                        <TextField
                            minRows={6}
                            multiline
                            value={comment}
                            onChange={(event) => handleCommentChange(event.target.value)}
                            placeholder={translate('orders:COMMENT')}
                            fullWidth
                        />
                    </Box>
                </Box>
                <Box display="flex" mt={2}>
                    <Box flexGrow={1} textAlign="left">
                        <Button type="button" onClick={onBackClick}>
                            {translate('common:BACK')}
                        </Button>
                    </Box>
                    <Box>
                        <Button
                            disabled={order.restorations.length === 0}
                            type="button"
                            onClick={onNextClick}
                            variant="contained"
                        >
                            {translate('common:NEXT_STEP')}
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Fragment>
    );
};

export default ConstructionsStep;
